import React from "react";
import CreatePasswordContainer from "../containers/CreatePasswordContainer"


function CreatePasswordScreen(){
    return(
             <CreatePasswordContainer />
       
    )
}

export default CreatePasswordScreen